import ProcessLog from './components/process-log/ProcessLog.vue'
import MonitoringLegacy from './components/monitoring-search/MonitoringLegacy.vue'

const routes = [
  {
    path: '/',
    name: 'keywords.monitoring',
    component: MonitoringLegacy
  },
  {
    path: 'process-log',
    name: 'monitoring.routes.process_log',
    component: ProcessLog
  }
]

export default routes
